<app-section
  titleSection="Informations Client"
  [isActivated]="informationsClient.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-informations-client-read-mode
      [informationsClient]="informationsClient"
    >
    </app-informations-client-read-mode>
  </div>

  <div edit-mode>
    <app-informations-client-edit-mode
      [informationsClient]="informationsClient"
      (informationsClientChanged)="onInformationsClientChanged($event)"
    >
    </app-informations-client-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
